<template>
  <div>
    <div class="input-group">
      <input
        type="text"
        ref="text"
        class="form-control"
        v-model="value.label"
        @focus="onFocus"
        v-bind="$attrs"
      >
      <span
        class="add-on"
        v-if="!$attrs.disabled"
      >
        <img
          v-if="!value.label"
          :src="`${$root.cdnUrl}assets/icon-arrow-down-gray.svg`"
        >
        <img
          v-else
          :src="`${$root.cdnUrl}assets/icon-close-gray.svg`"
          @click="clear"
        >
      </span>
    </div>

    <Modal
      :show="showModal"
      @close="close"
      class="modal-select"
    >
      <template slot="modal-title">
        <div class="modal-title">
          {{ getTitle }}
        </div>
      </template>
      <template slot="modal-body">
        <div class="content">
          <div class="input-group search left">
            <input
              type="text"
              ref="search"
              class="form-control"
              placeholder="Ara"
              v-model="search"
              @input="onSearch"
            >
            <span class="add-on">
              <img :src="`${$root.cdnUrl}assets/icon-search.png`">
            </span>
          </div>
          <ul class="options">
            <li
              v-for="(option, k) in getOptions"
              :key="k"
              @click="onSelect(option)"
            >
              <span>
                {{ option.label }}
                <small>
                  <b>{{ option.subLabel }}</b>
                </small>
              </span>
            </li>
            <li v-if="!getOptions.length">
              <span>Kayıt Bulunamadı.</span>
            </li>
          </ul>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal';
import { distance } from 'fastest-levenshtein';

export default {
  components: { Modal },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    max: {
      type: Number,
      default: () => 100,
    },
  },
  data () {
    return {
      search: '',
      showModal: false,
    };
  },
  computed: {
    getOptions () {
      const options = this.options;
      const search = this.search.toLocaleLowerCase('tr-TR').trim();
      if (options.length > 100) {
        return options
          .filter(option => option.label.toLowerCase().search(search) > -1)
          .sort((a, b) => distance(a.label.toLowerCase(), search) - distance(b.label.toLowerCase(), search))
          .splice(0, this.max);
      }
      return options.filter(option => option.label.toLocaleLowerCase('tr-TR').search(search) > -1)
        .map(option => ({
          ...option,
          order: option.label.toLowerCase().search(search),
        }))
        .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
    },
    getTitle () {
      return this.$attrs.title;
    },
  },
  methods: {
    onSearch () {
      this.$emit('onSearch', this.search);
    },
    onSelect (option) {
      this.$emit('input', option);
      this.$emit('onSelect', option);
      this.close();
    },
    async onFocus () {
      this.showModal = true;
      await this.$nextTick();
      this.$refs.text.blur();
      this.$emit('toggleModal', this.showModal);
    },
    close () {
      this.showModal = false;
      this.$emit('toggleModal', this.showModal);
    },
    clear () {
      this.$emit('input', {});
      this.$emit('onClear');
    },
  },
};
</script>

<style lang="scss" scoped>
  .content {
    margin: 0 -20px;
    .options {
      border-top: 1px solid #DEE0EB;
      list-style: none;
      margin: 0;
      padding: 0;
      overflow: auto;
      max-height: calc(100vh - 60px);
      li {
        position: relative;
        border-bottom: 1px solid #DEE0EB;
        span {
          display: block;
          padding: 15px;
          padding-right: 35px;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
          }
        }
      }
    }
    .input-group {
      margin: 0 15px 15px;
    }
  }

  .modal-select {
    ::v-deep .modal {
      border-radius: 15px 15px 0 0;
      height: 100%;
      .modal-body {
        min-height: 400px;
      }
      @media screen and (max-height: 550px) {
        top: initial;
        bottom: 0;
        .modal-body {
          margin: 0 -20px;
          min-height: 1px;
          .content {
            margin: 0;
            .options {
              max-height: 200px;
            }
          }
        }
      }
    }
  }
</style>
